export default __webpack_public_path__ + "static/media/balance_bike_limbo.b05d7308.jpeg";